export const parseJwt = token => {
  try {
    const base64Payload = token.split('.')[1]
    return JSON.parse(atob(base64Payload))
  } catch {
    return null
  }
}

export const isTokenExpired = (token, bufferSeconds = 60) => {
  const decoded = parseJwt(token)

  if (!decoded?.exp) return true

  const currentTime = Date.now() / 1000
  return decoded.exp < currentTime + bufferSeconds
}
